module.exports = __webpack_public_path__ + "img/stock5.d52293c0.png";